const CircleOutlineIcon = ({ size = 16, className = '' }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 20.0007C16.4183 20.0007 20 16.419 20 12.0007C20 7.58245 16.4183 4.00073 12 4.00073C7.58172 4.00073 4 7.58245 4 12.0007C4 16.419 7.58172 20.0007 12 20.0007ZM12 22.0007C17.5228 22.0007 22 17.5236 22 12.0007C22 6.47788 17.5228 2.00073 12 2.00073C6.47715 2.00073 2 6.47788 2 12.0007C2 17.5236 6.47715 22.0007 12 22.0007Z"
                fill="currentColor"
            />
        </svg>
    )
}

export default CircleOutlineIcon